import React, { useEffect, useRef, useState } from "react";
import { GrMoreVertical } from "react-icons/gr";
import { LuSearch } from "react-icons/lu";
import Pagination from "../../components/pagination/pagination";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import errorToast from "../../components/toasts/errorToast";
import { availableLanguages } from "../../components/data/languageData";
import moment from "moment";
import {
    PublishDocAction,
    translationsJobsListAction,
} from "../../redux/actions/translationAction";
import successToast from "../../components/toasts/successToast";
import CustomButton from "../../components/button/button";
import ReactSelectFiled from "../../components/forms/reactSelect";
import { getLangName, truncateString } from "../../components/helper";
import { useAuth } from '../../context/AuthContext';

export const RecentTranslations = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [filteredData, setFilteredData] = useState([]);
    const [fileNameFilter, setfileNameFilter] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [pageFilter, setPageFilter] = useState("");
    const [sourceLangFilter, setSourceLangFilter] = useState("");
    const [targetLangFilter, setTargetLangFilter] = useState("");
    const [filtersApplied, setFiltersApplied] = useState(false);
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")

    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [paginationData, setPaginationData] = useState({});
    const [showOptions, setShowOptions] = useState(false);
    const [showClearIndex, setShowClearIndex] = useState(null);
    const dropdownRef = useRef(null);
    const { isAdmin, isTeamLead } = useAuth();

    const [selectAll, setSelectAll] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [sortColumn, setSortColumn] = useState(null);
    const [sortOrder, setSortOrder] = useState("asc");

    // Function to handle checkbox changes
    const handleCheckboxChange = (docId) => {
        if (selectedItems.includes(docId)) {
            setSelectedItems(selectedItems.filter((item) => item !== docId));
        } else {
            setSelectedItems([...selectedItems, docId]);
        }
    };

    const handleSelectAll = () => {
        setSelectAll((prevSelectAll) => {
            const newSelectAll = !prevSelectAll;

            if (newSelectAll) {
                setSelectedItems(filteredData.reduce((acc, data) => {
                    if (data?.translation_status !== 'Published' && data?.id) {
                        acc.push(data.id);
                    }
                    return acc;
                }, []));
            } else {
                setSelectedItems([]);
            }
            return newSelectAll;
        });
    };

    useEffect(() => {
        setLoading(true);
        dispatch(
            translationsJobsListAction(
                {
                    page, page_size: rowsPerPage,
                    file_name: fileNameFilter,
                    status: statusFilter,
                    source_lang: sourceLangFilter,
                    target_lang: targetLangFilter,
                    no_of_pages: pageFilter,
                    from_date: startDate,
                    to_date: endDate,
                },
                onSuccess,
                onError
            )
        );
    }, [page, rowsPerPage, fileNameFilter, statusFilter, sourceLangFilter, targetLangFilter, pageFilter, startDate, endDate, dispatch]);

    const onSuccess = (data) => {
        setPaginationData(data?.data?.data?.pagination);
        setFilteredData(data?.data?.data?.jobs);
        setLoading(false);
    };
    const onError = (data) => {
        errorToast(data?.data?.message);
    };

    const handleSort = (column) => {
        const newSortOrder =
            sortColumn === column && sortOrder === "asc" ? "desc" : "asc";
        const sortedData = [...filteredData].sort((a, b) => {
            if (a[column] < b[column]) return newSortOrder === "asc" ? -1 : 1;
            if (a[column] > b[column]) return newSortOrder === "asc" ? 1 : -1;
            return 0;
        });
        setSortColumn(column);
        setSortOrder(newSortOrder);
        setFilteredData(sortedData);
    };

    const handleMoreOptions = (item, index) => {
        setShowClearIndex(index);
        setShowOptions(!showOptions);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setShowOptions(false);
            setShowClearIndex(null);
        }
    };

    const handlePublishClick = (id) => {
        setLoading(true);
        dispatch(PublishDocAction({ ids: id }, onPublishSuccess, onError));
    };

    const onPublishSuccess = (data) => {
        dispatch(
            translationsJobsListAction(
                { page, page_size: rowsPerPage },
                onSuccess,
                onError
            )
        );
        setShowOptions(false);
        setShowClearIndex(null);
        successToast(data?.data?.message);
    };

    // Function to apply filters and fetch filtered data
    const handleApplyFilters = () => {
        setLoading(true);
        setFiltersApplied(true);
        dispatch(translationsJobsListAction({
            page,
            page_size: rowsPerPage,
            file_name: fileNameFilter,
            status: statusFilter,
            source_lang: sourceLangFilter,
            target_lang: targetLangFilter,
            no_of_pages: pageFilter,
            from_date: startDate,
            to_date: endDate,
        }, onSuccess, onError));
    };

    const handleClear = () => {
        console.log(filtersApplied);
        setLoading(false);
        setfileNameFilter('');
        setStatusFilter('');
        setSourceLangFilter('');
        setTargetLangFilter('');
        setStartDate('');
        setEndDate('')
        setPageFilter('');
        setFiltersApplied(false);
    };
    const handleGetAllRecords = () => {
        setLoading(true);
        setfileNameFilter('');
        setStatusFilter('');
        setSourceLangFilter('');
        setTargetLangFilter('');
        setStartDate('');
        setEndDate('')
        setPageFilter('');
        setFiltersApplied(true);
        dispatch(
            translationsJobsListAction(
                {
                    page, page_size: rowsPerPage,
                },
                onSuccess,
                onError
            )
        );
    };

    if (!isAdmin || isTeamLead) {
        return (
            <div className="w-100 d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
                <i className="bi bi-shield-lock fs_40 text-danger mb-3"></i>
                <h5 className="fw_600">Access Denied</h5>
                <p className="text-muted fs_14">This page is only accessible to company administrators and team leads.</p>
            </div>
        );
    }

    return (
        <div className="d-flex overflow-auto vh-100" onClick={handleClickOutside}>
            <div className="w-100">
                <div className="w-100 header align-items-center border-bottom  d-flex position-sticky top-0 bg-white py-2 justify-content-between z-1">
                    <h2 className="fs_20 fw_400 fn_Roboto text-start px-3 pt-1 text-nowrap">Recent Translations</h2>
                    <div className='d-flex gap-3 px-3'>
                        <CustomButton className='cursor_pointer fs_18 pb-1 d-flex align-items-center justify-content-center text-nowrap'
                            style={{ height: '35px', width: '180px' }} variant='primary'
                            disabled={selectedItems.length === 0}
                            onClick={() => {
                                console.log(selectedItems, 'selectedItems');
                                navigate('/assign-user', { state: { jobs: selectedItems, is_reassign: false } })
                            }}>
                            Send for post-editing</CustomButton>
                        <CustomButton className='cursor_pointer fs_18 pb-1 d-flex align-items-center justify-content-center'
                            style={{ height: '35px', width: '110px' }} variant='primary'
                            disabled={selectedItems.length === 0}
                            onClick={() => {
                                console.log(selectedItems, 'selectedItems');
                                handlePublishClick(selectedItems);
                            }}
                        >Publish</CustomButton>
                    </div>
                </div>

                <div className='d-flex flex-wrap gap-3 m-3'>
                    <div className='text-start'>
                        <span className="">File Name</span>
                        <div style={{ width: '14rem' }}>
                            <input
                                type='text'
                                name='file_name'
                                className='input-field w-100'
                                placeholder="Enter name"
                                value={fileNameFilter}
                                onChange={(e) => setfileNameFilter(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className='text-start' style={{ width: '14rem' }}>
                        <ReactSelectFiled
                            onChange={(value) => setSourceLangFilter(value)}
                            options={availableLanguages}
                            label="Source Language"
                            value={sourceLangFilter}
                        />
                    </div>

                    <div className='text-start' style={{ width: '14rem' }}>
                        <ReactSelectFiled
                            onChange={(value) => setTargetLangFilter(value)}
                            options={availableLanguages}
                            label="Target Language"
                            value={targetLangFilter}
                        />
                    </div>
                    <div className='text-start' style={{ width: '14rem' }}>
                        <ReactSelectFiled
                            onChange={(value) => setStatusFilter(value)}
                            options={[
                                {
                                    label: "Completed",
                                    value: "Completed"
                                },
                                {
                                    label: "In Progress",
                                    value: "In Progress"
                                },
                                {
                                    label: "Published",
                                    value: "Published"
                                },
                                {
                                    label: "Review",
                                    value: "Review"
                                },
                                {
                                    label: "Sent Post Editing",
                                    value: "Sent Post Editing"
                                },
                                {
                                    label: "Translated",
                                    value: "Translated"
                                },
                            ]}
                            label={"Translation Status"}
                            value={statusFilter}
                        />
                    </div>

                    <div className='text-start'>
                        <span className="">Pages</span>
                        <div className='' style={{ width: '14rem' }}>
                            <input
                                type='number'
                                name='pages'
                                className='input-field w-100'
                                placeholder="Enter a number"
                                value={pageFilter}
                                onChange={(e) => setPageFilter(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='text-start'>
                        <span className="">From Date</span>
                        <div className='' style={{ width: '14rem' }}>
                            <input
                                type='date'
                                name='startDate'
                                className='input-field w-100'
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                max={new Date().toISOString().split('T')[0]}
                            />
                        </div>
                    </div>
                    <div className='text-start'>
                        <span className="">To Date</span>
                        <div className='' style={{ width: '14rem' }}>
                            <input
                                type='date'
                                name='endDate'
                                className='input-field w-100'
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                max={new Date().toISOString().split('T')[0]}
                            />
                        </div>
                    </div>

                </div>

                <div className="d-flex flex-wrap justify-content-start gap-3 px-3 text-nowrap">
                    <CustomButton variant="primary" onClick={handleApplyFilters} disabled={!fileNameFilter && !statusFilter && !sourceLangFilter && !pageFilter && !targetLangFilter && !startDate && !endDate} >
                        Apply Filters
                    </CustomButton>
                    <CustomButton variant="primary" onClick={handleGetAllRecords}>
                        Show All
                    </CustomButton>
                    <CustomButton variant="secondary" onClick={handleClear}>
                        Clear Filters
                    </CustomButton>
                </div>

                {filtersApplied && (
                    <>
                        <div className="m-3">
                            <div className="table-responsive overflow-auto" style={{ minHeight: '22rem' }}>
                                <table className="table table-bordered ">
                                    <thead className="table-light">
                                        <tr className="text-start text-nowrap">
                                            {(isAdmin || isTeamLead) && (
                                                <th width={"2%"} className="fw_400">
                                                    <input
                                                        type="checkbox"
                                                        checked={selectAll}
                                                        onChange={handleSelectAll}
                                                        aria-label="Select all documents"
                                                    />
                                                </th>
                                            )}
                                            <th
                                                width={"10%"}
                                                className="fw_400"
                                                onClick={() => handleSort("file_name")}
                                            >
                                                File Name{" "}
                                                {sortColumn === "file_name" &&
                                                    (sortOrder === "asc" ? "↑" : "↓")}
                                            </th>
                                            <th
                                                width={"10%"}
                                                className="fw_400"
                                                onClick={() => handleSort("source_lang")}
                                            >
                                                Source Language{" "}
                                                {sortColumn === "source_lang" &&
                                                    (sortOrder === "asc" ? "↑" : "↓")}
                                            </th>

                                            <th
                                                width={"10%"}
                                                className="fw_400"
                                                onClick={() => handleSort("target_lang")}
                                            >
                                                Target Language{" "}
                                                {sortColumn === "target_lang" &&
                                                    (sortOrder === "asc" ? "↑" : "↓")}
                                            </th>
                                            <th
                                                width={"10%"}
                                                className="fw_400"
                                                onClick={() => handleSort("user_id")}
                                            >
                                                Translated By{" "}
                                                {sortColumn === "user_id" &&
                                                    (sortOrder === "asc" ? "↑" : "↓")}
                                            </th>

                                            <th
                                                width={"10%"}
                                                className="fw_400"
                                                onClick={() => handleSort("translation_status")}
                                            >
                                                Translation Status{" "}
                                                {sortColumn === "translation_status" &&
                                                    (sortOrder === "asc" ? "↑" : "↓")}
                                            </th>
                                            <th
                                                width={"6%"}
                                                className="fw_400"
                                                onClick={() => handleSort("no_of_pages")}
                                            >
                                                Pages{" "}
                                                {sortColumn === "no_of_pages" &&
                                                    (sortOrder === "asc" ? "↑" : "↓")}
                                            </th>
                                            <th
                                                width={"6%"}
                                                className="fw_400"
                                            >
                                                Created Date
                                            </th>

                                            {(isAdmin || isTeamLead) && (
                                                <th width={"2%"} className="fw_400"></th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan="9">Loading...</td>
                                            </tr>
                                        ) : filteredData?.length > 0 ? (
                                            filteredData?.map((item, index) => (
                                                <tr key={index} className="text-start">
                                                    {(isAdmin || isTeamLead) && (
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                disabled={item?.translation_status === 'Published'}
                                                                checked={selectedItems.includes(item.id)}
                                                                onChange={() => handleCheckboxChange(item.id)}
                                                                aria-label={`Select document ${item?.name}`}
                                                            />
                                                        </td>
                                                    )}
                                                    <td>
                                                        <a href={`/view-recent-translation/${item.id}`} className='cursor_pointer text-decoration-none' >
                                                            {truncateString(item?.file_name)}
                                                        </a>
                                                    </td>
                                                    <td>{getLangName(item?.source_lang)}</td>
                                                    <td>{getLangName(item?.target_lang)}</td>
                                                    <td>{truncateString(item?.user?.email)}</td>
                                                    <td>{item?.translation_status}</td>
                                                    <td>{item?.no_of_pages}</td>
                                                    <td>{moment(item?.createdAt).format('MM/DD/YY, hh:mm A')}</td>
                                                    {isAdmin || isTeamLead ? (
                                                        <td>
                                                            <GrMoreVertical
                                                                className="cursor_pointer"
                                                                onClick={() => handleMoreOptions(item, index)}
                                                            />
                                                            {showOptions && showClearIndex === index && (
                                                                <div
                                                                    className="position-relative"
                                                                    ref={dropdownRef}
                                                                >
                                                                    <div
                                                                        className="position-absolute"
                                                                        style={{ left: "-4rem" }}
                                                                    >
                                                                        <div
                                                                            className="card"
                                                                            style={{ width: "4rem" }}
                                                                        >
                                                                            <div className="card-body p-2 fs_14">
                                                                                <label
                                                                                    className="d-block text-center cursor_pointer hover-effect text-nowrap"
                                                                                    onClick={() => { navigate(`/view-recent-translation/${item.id}`) }}
                                                                                >
                                                                                    View
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </td>
                                                    ) : null}
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="9">No rows to display</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {paginationData?.total > 10 && (
                            <div className="px-5 pb-4 mt-2 d-flex justify-content-end">
                                <Pagination
                                    data={paginationData}
                                    nextFunc={() => setPage(page + 1)}
                                    prevFunc={() => setPage(page - 1)}
                                    setPageRowFunc={(value) => {
                                        setPage(1);
                                        setRowsPerPage(value);
                                    }}
                                />
                            </div>
                        )}
                    </>)}

            </div>
        </div>
    );
};
